var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4924_99303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6781 11.319C10.6548 11.319 4.15065 17.7574 4.15065 25.6995V27.1496C4.15065 29.0406 5.69926 30.5736 7.60956 30.5736H8.70362C9.83315 30.5736 10.7553 29.6794 10.7785 28.5615L10.7939 27.8203C10.7991 27.5715 10.9403 27.345 11.1626 27.2288C11.385 27.1126 11.6535 27.125 11.864 27.2612L13.0017 27.9971C16.4504 30.2279 20.9057 30.2279 24.3544 27.9971L25.4921 27.2612C25.7026 27.125 25.9712 27.1126 26.1935 27.2288C26.4159 27.345 26.557 27.5715 26.5622 27.8203L26.5776 28.5615C26.6009 29.6794 27.523 30.5736 28.6525 30.5736H29.7466C31.6569 30.5736 33.2055 29.0406 33.2055 27.1496V25.6995C33.2055 17.7574 26.7013 11.319 18.6781 11.319ZM2.76709 25.6995C2.76709 17.001 9.89068 9.94946 18.6781 9.94946C27.4655 9.94946 34.589 17.001 34.589 25.6995V27.1496C34.589 29.797 32.421 31.9431 29.7466 31.9431H28.6525C26.9322 31.9431 25.5005 30.6986 25.237 29.0623L25.1113 29.1436C21.2027 31.6719 16.1534 31.6719 12.2449 29.1436L12.1191 29.0623C11.8556 30.6986 10.424 31.9431 8.70362 31.9431H7.60956C4.93514 31.9431 2.76709 29.797 2.76709 27.1496V25.6995Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9863 7.53086C7.99119 7.89109 0 16.0256 0 26.0076V27.837C0 31.2407 2.78749 34 6.22603 34H31.1302C34.5687 34 37.3562 31.2407 37.3562 27.837V26.0076C37.3562 16.0256 29.365 7.89109 19.3699 7.53086V4.79352H17.9863V7.53086ZM18.6781 8.88798C9.12659 8.88798 1.38356 16.5527 1.38356 26.0076V27.837C1.38356 30.4843 3.55161 32.6305 6.22603 32.6305H31.1302C33.8046 32.6305 35.9726 30.4843 35.9726 27.837V26.0076C35.9726 16.5527 28.2296 8.88798 18.6781 8.88798Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6783 1.36957C17.9141 1.36957 17.2947 1.98275 17.2947 2.73914C17.2947 3.49553 17.9141 4.10871 18.6783 4.10871C19.4424 4.10871 20.0618 3.49553 20.0618 2.73914C20.0618 1.98275 19.4424 1.36957 18.6783 1.36957ZM15.9111 2.73914C15.9111 1.22635 17.15 0 18.6783 0C20.2065 0 21.4454 1.22635 21.4454 2.73914C21.4454 4.25192 20.2065 5.47828 18.6783 5.47828C17.15 5.47828 15.9111 4.25192 15.9111 2.73914Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.2778,
    cy: 21.7222,
    r: 1.88889,
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5,
    cy: 21.7222,
    rx: 1.88889,
    ry: 1.88889,
    fill: "#243CBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4924_99303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5db6d09bed543cfab4df6b159762d0a2.svg";
export { ForwardRef as ReactComponent };